(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vue"));
	else if(typeof define === 'function' && define.amd)
		define("jvue", ["vue"], factory);
	else if(typeof exports === 'object')
		exports["jvue"] = factory(require("vue"));
	else
		root["jvue"] = factory(root["vue"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_99__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition